function allButLastDigit(value) {
  return Math.floor(value / 10);
}

export { allButLastDigit };
//# sourceMappingURL=all-but-last-digit.js.map
